import { ReactElement, ChangeEventHandler, FocusEventHandler } from 'react'
import styled from '@emotion/styled/macro'

const StyledCheckbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 2px !important;

  &:not(:checked) {
    border-color: ${props => props.theme['secondary-200']};
    border-width: 1px;
  }

  &:checked {
    background-color: ${props => props.theme.primary};
    border-color: ${props => props.theme.primary};
  }
  &:focus {
    box-shadow: 0 0 0 0.05rem ${props => props.theme['primary-100']};
  }
`

const Checkbox = ({
  id,
  name,
  label,
  description,
  checked,
  disabled = false,
  reverseLabel,
  className = '',
  containerClassName = '',
  labelClassName = '',
  onChange,
  onBlur,
  onFocus,
}: {
  id?: string
  name?: string
  label?: string
  description?: string
  checked?: boolean
  disabled?: boolean
  reverseLabel?: boolean
  containerClassName?: string
  className?: string
  labelClassName?: string
  descriptionClassName?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
  onFocus?: FocusEventHandler<HTMLInputElement>
}): ReactElement => {
  return (
    <div
      className={`form-check ${
        reverseLabel ? 'form-check-reverse' : ''
      } ${containerClassName}`}
    >
      {label && (
        <div className='d-inline-block text-start'>
          <label className={`form-check-label ${labelClassName}`} htmlFor={id}>
            {label}
          </label>
          {description && (
            <div className='form-label-description'>{description}</div>
          )}
        </div>
      )}

      <StyledCheckbox
        className={`form-check-input flex-shrink-0 ${className}`}
        type='checkbox'
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </div>
  )
}

export default Checkbox
